import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-419d0d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"padding":"0"},
  class: "zone-mgmt-edit"
}
const _hoisted_2 = { class: "zone-mgmt-edit-header" }
const _hoisted_3 = { class: "zone-mgmt-edit-body" }
const _hoisted_4 = {
  key: 0,
  style: {"position":"absolute","right":"0","cursor":"pointer","z-index":"1"},
  class: "del"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff0b0b","font-size":"14px","margin-right":"2px"} }, " * ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#4c4c4c","font-size":"14px"} }, "封面图", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#898989","font-size":"14px"} }, " 建议上传 16：9, 最大 20M,格式为JPEG,JPG,BMP,PNG 的图片 ", -1))
const _hoisted_10 = { style: {"margin-top":"20px"} }
const _hoisted_11 = {
  style: {"justify-content":"flex-start","margin":"10px"},
  class: "xrk-form-item__label"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff0b0b","font-size":"14px","margin-right":"2px"} }, " * ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推广内容", -1))
const _hoisted_14 = { class: "drag-table-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"70px","border-left":"1px solid #f6f6f6","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}, " 序号 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"110px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}, " 编号ID ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"130px","border-right":"1px solid #f6f6f6","padding":"0 10px"},
  class: "drag-table-header-item"
}, " 资讯标题 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"150px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}, " 作者 ", -1))
const _hoisted_19 = {
  key: 0,
  style: {"width":"130px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}, " 资讯状态 ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"83px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}, " 操作 ", -1))
const _hoisted_22 = {
  key: 0,
  style: {"text-align":"center","line-height":"400px","border":"1px solid #f6f6f6"}
}
const _hoisted_23 = {
  style: {"width":"70px","border-left":"1px solid #f6f6f6","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_24 = {
  style: {"width":"110px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_25 = {
  style: {"width":"130px","border-right":"1px solid #f6f6f6","padding":"0 10px"},
  class: "drag-table-header-item"
}
const _hoisted_26 = {
  style: {"width":"150px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_27 = {
  key: 0,
  style: {"width":"130px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_28 = {
  style: {"width":"100px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_29 = {
  style: {"width":"83px","border-right":"1px solid #f6f6f6"},
  class: "drag-table-header-item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.myxrk.com/myxrk-v2/front-end/assets/oss/topic/svg/yidong.svg",
  class: "move",
  style: {"cursor":"move","margin-left":"9px"}
}, null, -1))
const _hoisted_31 = {
  key: 0,
  class: "zone-mgmt-edit-body-right"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zone-mgmt-edit-body-right-title" }, "规则设置", -1))
const _hoisted_33 = { style: {"border-bottom":"1px solid #f6f6f6","padding-bottom":"10px"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","color":"#818181","margin":"10px 0"} }, " 移动端常规形式 ", -1))
const _hoisted_35 = { style: {"border-bottom":"1px solid #f6f6f6","padding-bottom":"10px"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","color":"#818181","margin":"10px 0"} }, " 排序 ", -1))
const _hoisted_37 = { class: "affix-box" }

import { useRoute, useRouter } from 'vue-router';
import { reactive, ref } from 'vue';
import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseFormRef,
  createDialog,
  BaseSwitch,
  XrkMessage,
  BaseUpload,
  BaseIcon,
  BaseToolTip
} from 'xrk-components';
import {
  zoneDetail,
  promotionContent,
  addOrUpdate,
  checkInfoStatus
} from '../data-source/apis';
import { uploadApi } from '@data-source/common/apis';
import draggable from 'vuedraggable';
import AddRelation from '../components/add-relation.vue';
import { Delete } from '@element-plus/icons-vue';
import QuestionPreview from '../components/question-preview.vue';

type DataType = {
  id?: number;
  title: string;
  sortMode: number; //排序方式   1 手动设置  2 自动倒序
  mobileShowMode: number; // 移动端展示样式  1 平铺显示 2 折叠显示
  banners: {
    id?: number;
    imgUrl: any[];
    title: string;
  }[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'zone-mgmt-detail',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const id: number = +route.query?.id || null;
const hasForm: number = +route.query?.hasForm;

const relationTableData = ref([]);

const drag = ref(false);

const BaseFormItemBaseConfig = {
  'label-width': '110px',
  'label-position': 'top'
};

const formRef = ref<BaseFormRef<DataType>>();

const formData = reactive<DataType>({
  title: '',
  banners: [
    {
      imgUrl: [],
      title: '',
      id: null
    }
  ],
  sortMode: 2,
  mobileShowMode: 1
});

const onAddBanner = () => {
  if (formData.banners.length >= 5) {
    XrkMessage.warning('封面图最多上传 5 张');
    return;
  }
  formData.banners.push({
    imgUrl: [],
    title: '',
    id: null
  });
};

const switchLoading = ref(false);
const switchBeforeChange = async row => {
  switchLoading.value = true;
  return new Promise((resolve, reject) => {
    checkInfoStatus({
      infoId: row.id,
      hasForm,
      status: +!row.visible
    })
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        reject(false);
      })
      .finally(() => {
        switchLoading.value = false;
      });
  });
};

const onPreviewForm = async row => {
  await createDialog({
    title: '预览',
    showClose: true,
    showFooter: false,
    customClass: 'zone-mgmt-question-preview',
    contentRender: () => (
      <div style="padding:20px">
        <QuestionPreview
          projectType={row.sceneType}
          tempId={row.surveyId}
        ></QuestionPreview>
      </div>
    )
  });
  const dialogElement = document.querySelector('.zone-mgmt-question-preview');
  if (dialogElement) {
    (dialogElement as HTMLElement).style.height = '900px';
    (dialogElement as HTMLElement).style.maxHeight = '900px';
  }
};

const onChangeUpload = key => {
  formRef.value.validateField(key);
};
const onDelBanner = (index: number) => {
  formData.banners.splice(index, 1);
};

const onChangeSelect = (selectOptions, index) => {
  formData.banners[index].title = selectOptions[0].title;
};

const addRelationRef = ref(null);
const onAddRelation = () => {
  createDialog({
    width: 960,
    title: '选择推广内容',
    showClose: true,
    showFooter: false,
    contentRender: () => (
      <>
        <AddRelation
          ref={addRelationRef}
          relationTableData={relationTableData}
          hasForm={hasForm}
        ></AddRelation>
      </>
    ),
    footerRender: done => (
      <>
        <BaseButton onClick={done} type="default">
          关闭
        </BaseButton>
        <BaseButton
          onClick={() => {
            const data = addRelationRef.value.getSelectionRows();
            if (data.length === 0) {
              XrkMessage.error('请至少选择1条资讯');
              return;
            }
            relationTableData.value = data;
            done();
          }}
          type="primary"
        >
          保存
        </BaseButton>
      </>
    )
  });
};

const getJumpContent = async title => {
  const data = await promotionContent({
    title: title,
    hasForm,
    pageSize: 80
  });
  if (hasForm === 1) {
    data.data.list.forEach(item => {
      item.title = `${item.title}（${item.surveyCode}）`;
    });
  }
  return data;
};

const initData = async () => {
  if (id) {
    const { data } = await zoneDetail({ id, hasForm });
    formData.banners = data.banners.map(item => {
      return {
        imgUrl: [item.imgUrl],
        title: item.title,
        id: item.id
      };
    });
    formData.title = data.title;
    formData.id = data.id;
    formData.sortMode = data.sortMode;
    formData.mobileShowMode = data.mobileShowMode;
    relationTableData.value = data.relationships.reverse();
    formData.banners = data.banners.map(item => {
      return {
        imgUrl: [{ url: item.imgUrl }],
        title: item.title,
        id: item.id
      };
    });
  }
};

const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const httpRequest = ({ file }: { file: File }, index) => {
  return new Promise((resolve, reject) => {
    uploadApi({ file })
      .then(res => {
        formData.banners[index].imgUrl[0].url = res.data.fileUrl;
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const onRemoveRelation = async (row, index) => {
  relationTableData.value.splice(index, 1);
  XrkMessage.success('移除成功');
};

const onDragEnd = async () => {
  drag.value = false;
};

const onSave = async () => {
  await formRef.value?.validate();
  if (relationTableData.value.length === 0) {
    XrkMessage.warning('请选择推广内容');
    return;
  }
  //组合数据
  const params = {
    ...formData,
    id,
    hasForm,
    banners: formData.banners.map(item => {
      return {
        id: item.id,
        imgUrl: item.imgUrl[0].url,
        title: item.title
      };
    }),
    relationships: relationTableData.value.map((item, index) => {
      return {
        id: item.id,
        visible: item.visible,
        weight: index
      };
    })
  };
  await addOrUpdate(params);
  XrkMessage.success('保存成功');
  router.back();
};

const onCancelClick = () => {
  createDialog({
    width: 350,
    title: '提示',
    showClose: true,
    content: '当前页面有未保存内容，是否继续返回',
    beforeConfirm: async done => {
      done();
      router.back();
    }
  });
};

if (id) {
  initData();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(id) ? '编辑专区' : '新增专区'), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(BaseForm), {
        style: {"margin":"20px","flex":"1"},
        class: "zone-mgmt-edit-body-left",
        ref_key: "formRef",
        ref: formRef,
        "label-position": "right",
        model: formData
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseFormItem), _mergeProps(BaseFormItemBaseConfig, {
            label: "专区名称",
            prop: "title",
            rules: [
            {
              required: true,
              message: '专区名称不能为空',
              trigger: 'blur'
            }
          ]
          }), {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                placeholder: "",
                style: {"width":"100%"},
                modelValue: formData.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.title) = $event)),
                "show-word-limit": "",
                maxlength: 20
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 16),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.banners, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: {"border-top":"1px solid #f0f0f0","border-bottom":"1px solid #f0f0f0","padding":"20px 0 0 0","position":"relative"},
              key: index
            }, [
              (index !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (onDelBanner(index))
                    }, [
                      _createVNode(_unref(BaseIcon), {
                        size: "20",
                        color: "#4c4c4c",
                        class: "addition-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Delete))
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              (index === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createVNode(_unref(BaseButton), {
                      onClick: onAddBanner,
                      style: {"margin":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 添加封面 ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(BaseFormItem), _mergeProps({ ref_for: true }, BaseFormItemBaseConfig, {
                style: {"flex-direction":"column"},
                prop: 'banners.' + index,
                rules: [
              {
                required: true,
                trigger: 'blur',
                validator: (_, _value, callback) => {
                  if (_value.imgUrl.length === 0) {
                    return callback('请上传封面图');
                  }
                  callback();
                }
              }
            ]
              }), {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseUpload), {
                    style: {"width":"248px"},
                    ref_for: true,
                    ref: "baseUploadRefVideoCover",
                    listType: "picture-card",
                    accept: ['.jpg', '.png', '.jpeg', '.bmp'],
                    limit: 1,
                    limitSize: 20,
                    autoUpload: true,
                    onError: onError,
                    httpRequest: e => httpRequest(e, index),
                    onChange: ($event: any) => (onChangeUpload('banners.' + index)),
                    fileList: item.imgUrl,
                    "onUpdate:fileList": ($event: any) => ((item.imgUrl) = $event)
                  }, {
                    tip: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["httpRequest", "onChange", "fileList", "onUpdate:fileList"])
                ]),
                _: 2
              }, 1040, ["prop", "rules"]),
              _createVNode(_unref(BaseFormItem), _mergeProps({ ref_for: true }, BaseFormItemBaseConfig, {
                label: "跳转内容",
                prop: "id"
              }), {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    style: {"width":"100%"},
                    modelValue: item.id,
                    "onUpdate:modelValue": ($event: any) => ((item.id) = $event),
                    placeholder: "请选择跳转内容",
                    "label-key": "title",
                    "value-key": "id",
                    init: "",
                    clearable: "",
                    filterUseRemote: "",
                    remoteMethod: getJumpContent,
                    onChange: 
                (e, selectOptions) => {
                  onChangeSelect(selectOptions, index);
                }
              
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _: 2
              }, 1040)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createVNode(_unref(BaseButton), {
                onClick: onAddRelation,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 请选择推广内容 ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              hasForm
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 关联表单编号 "))
                : _createCommentVNode("", true),
              _hoisted_20,
              _hoisted_21
            ]),
            (relationTableData.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 暂无数据 "))
              : (_openBlock(), _createBlock(_unref(draggable), {
                  key: 1,
                  style: {"height":"340px","overflow":"auto","border":"1px solid #f6f6f6"},
                  modelValue: relationTableData.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((relationTableData).value = $event)),
                  animation: "500",
                  handle: ".move",
                  onStart: _cache[2] || (_cache[2] = ($event: any) => (drag.value = true)),
                  onEnd: onDragEnd
                }, {
                  item: _withCtx(({ element, index }) => [
                    _createElementVNode("div", {
                      style: _normalizeStyle({
                  background: index % 2 ? '#F4F4F5' : '#fff',
                  borderBottom: '1px solid #f6f6f6'
                }),
                      class: "drag-table-header"
                    }, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(index + 1), 1),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(element.infoCode), 1),
                      _createVNode(_unref(BaseToolTip), {
                        content: element.title
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(element.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(element.author), 1),
                      hasForm
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_unref(BaseButton), {
                              style: {"font-size":"14px"},
                              type: "text",
                              disabled: !element.surveyCode || !element.surveyId,
                              onClick: ($event: any) => (onPreviewForm(element))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(element.surveyCode), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_unref(BaseSwitch), {
                          loading: switchLoading.value,
                          "before-change": 
                      async () => {
                        await switchBeforeChange(element);
                      }
                    ,
                          modelValue: element.visible,
                          "onUpdate:modelValue": ($event: any) => ((element.visible) = $event),
                          "active-value": 1,
                          "inactive-value": 0
                        }, null, 8, ["loading", "before-change", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_unref(BaseButton), {
                          onClick: ($event: any) => (onRemoveRelation(element, index)),
                          style: {"font-size":"14px"},
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 移除 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _hoisted_30
                      ])
                    ], 4)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
          ])
        ]),
        _: 1
      }, 8, ["model"]),
      hasForm
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", null, [
                _createVNode(_unref(BaseSwitch), {
                  size: "large",
                  modelValue: formData.mobileShowMode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.mobileShowMode) = $event)),
                  "active-text": "平铺显示",
                  "inactive-text": "折叠显示",
                  "active-value": 1,
                  "inactive-value": 2
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", null, [
                _createVNode(_unref(BaseSwitch), {
                  size: "large",
                  modelValue: formData.sortMode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.sortMode) = $event)),
                  "active-text": "自动排序",
                  "inactive-text": "手动设置",
                  "active-value": 2,
                  "inactive-value": 1
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancelClick
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { onClick: onSave }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})